//region :: Imports ::
import {evalulateBool, MBoolean} from '../../Toolkit/Components/Controls/Control';
import MComponent from '../../Toolkit/Components/Component';
import {ReactElement} from 'react';
import {MNullable, setFieldValue} from '../../Toolkit/Utils';
import {FieldProps} from 'formik';
import {AutoComplete, AutoCompleteChangeParams, AutoCompleteCompleteMethodParams} from 'primereact/autocomplete';

//endregion

/** */
type Props = {
    id: string;
    initialValue?: MNullable<string>;
    suggestions: string[];
    placeholderText?: string;
    isBusy?: MBoolean;
    fieldProps?: FieldProps;
    disabled: MBoolean;
    className?: string;
    onChange?: (newValue: MNullable<string>) => void;
}

/** */
type State = {
    value: MNullable<string>;
    suggestionList: string[];
}

/** */
class MAutoComplete extends MComponent<Props, State> {

    /** */
    public constructor(props: Props) {
        super(props);

        this.bindMethods();
        this.initializeState();

    }

    /** */
    private bindMethods(): void {

        this.autoComplete_OnChange = this.autoComplete_OnChange.bind(this);
        this.autoComplete_OnComplete = this.autoComplete_OnComplete.bind(this);

    }

    /** */
    private initializeState(): void {

        this.state = {
            value: this.props.initialValue === undefined ? null : this.props.initialValue,
            suggestionList: this.props.suggestions
        };
        setFieldValue(this.props.fieldProps, this.state.value);

    }

    /** */
    private autoComplete_OnChange(params: AutoCompleteChangeParams): void {
        this.setValue(params.value);
    }

    private autoComplete_OnComplete(event: AutoCompleteCompleteMethodParams):void  {
        if(!event.query.trim().length) {
            this.safeSetState(draft => draft.suggestionList = this.props.suggestions)
        } else {
            this.safeSetState(draft => draft.suggestionList = this.props.suggestions
                                                           .filter(e => e.toLowerCase().startsWith(event.query.toLowerCase()))
                                                           .map(e => e));
        }
    }

    /** */
    public setValue(newValue: MNullable<string>): void {

        this.safeSetState((draft: State) => draft.value = newValue);
        setFieldValue(this.props.fieldProps, newValue);
        this.props.onChange?.(newValue);

    }

    /** */
    public componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {

        if(this.props.fieldProps?.field.value !== prevProps.fieldProps?.field.value) {

            this.safeSetState((draft: State) =>
                draft.value = this.props.fieldProps!.field.value);

        }

    }

    /** */
    public render(): ReactElement {

        return (
            <AutoComplete id={this.props.id}
                          suggestions={this.state.suggestionList}
                          placeholder={this.props.placeholderText}
                          disabled={evalulateBool(this.props.disabled)}
                          className={this.props.className}
                          {
                            ...this.props.fieldProps?.field
                            }
                          value={this.state.value}
                          onChange={this.autoComplete_OnChange}
                          completeMethod={this.autoComplete_OnComplete}
                          dropdown
            />
        );

    }

}

export default MAutoComplete;
